import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getArticles } from '@/content/articles';

const articleImages: Record<string, string> = {
  'allchinabuy-spreadsheet-guide':
    'https://readdy.ai/api/search-image?query=A%20bright%20tidy%20desk%20scene%20with%20a%20laptop%20showing%20a%20clean%20product%20spreadsheet%20alongside%20folded%20clothing%20and%20a%20notebook%20on%20a%20warm%20cream%20background%20soft%20natural%20light%20editorial%20photography%20warm%20beige%20and%20sage%20tones%20clean%20composition&width=900&height=600&seq=article-spreadsheet&orientation=landscape&nocache=true',
  'how-to-use-allchinabuy-spreadsheet':
    'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20using%20a%20tablet%20to%20browse%20an%20organized%20product%20list%20next%20to%20a%20cup%20of%20coffee%20on%20a%20light%20wooden%20desk%20bright%20airy%20workspace%20photography%20soft%20daylight%20warm%20neutral%20palette%20crisp%20detail&width=900&height=600&seq=article-howto&orientation=landscape&nocache=true',
  'allchinabuy-spreadsheet-for-beginners':
    'https://readdy.ai/api/search-image?query=A%20simple%20starter%20desk%20with%20an%20open%20notebook%20a%20pen%20and%20a%20smartphone%20showing%20a%20shopping%20app%20on%20a%20soft%20mint%20green%20background%20clean%20minimal%20beginner%20friendly%20concept%20photography%20bright%20airy%20lighting&width=900&height=600&seq=article-beginners&orientation=landscape&nocache=true',
  'allchinabuy-trusted-sellers-guide':
    'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20seller%20profile%20with%20a%20five%20star%20rating%20and%20product%20thumbnails%20held%20against%20a%20blurred%20warm%20retail%20shelf%20background%20shallow%20depth%20of%20field%20trustworthy%20shopping%20concept%20clean%20photography&width=900&height=600&seq=article-sellers&orientation=landscape&nocache=true',
  'allchinabuy-shipping-cost-guide':
    'https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20cardboard%20shipping%20boxes%20with%20a%20measuring%20tape%20and%20a%20small%20calculator%20on%20a%20soft%20blue%20desk%20surface%20clean%20minimal%20logistics%20concept%20photography%20bright%20airy%20lighting%20simple%20composition&width=900&height=600&seq=article-shipping&orientation=landscape&nocache=true',
  'allchinabuy-warehouse-guide':
    'https://readdy.ai/api/search-image?query=A%20clean%20modern%20warehouse%20aisle%20with%20organized%20shelves%20of%20labeled%20boxes%20and%20parcels%20warm%20overhead%20lighting%20soft%20depth%20perspective%20bright%20minimal%20fulfillment%20center%20photography&width=900&height=600&seq=article-warehouse&orientation=landscape&nocache=true',
  'allchinabuy-qc-guide':
    'https://readdy.ai/api/search-image?query=A%20person%20inspecting%20the%20stitching%20and%20label%20of%20a%20folded%20garment%20under%20a%20bright%20work%20lamp%20on%20a%20white%20table%20with%20a%20magnifying%20glass%20nearby%20quality%20control%20concept%20clean%20bright%20clinical%20photography%20crisp%20detail&width=900&height=600&seq=article-qc&orientation=landscape&nocache=true',
  'allchinabuy-coupon-discount-guide':
    'https://readdy.ai/api/search-image?query=A%20gift%20box%20with%20a%20bright%20ribbon%20and%20a%20discount%20price%20tag%20resting%20on%20a%20soft%20pastel%20yellow%20background%20with%20scattered%20coins%20clean%20minimal%20savings%20concept%20photography%20bright%20cheerful%20lighting&width=900&height=600&seq=article-coupon&orientation=landscape&nocache=true',
  'is-allchinabuy-legit-safety':
    'https://readdy.ai/api/search-image?query=A%20padlock%20with%20a%20shield%20icon%20and%20a%20subtle%20security%20badge%20on%20a%20calm%20light%20gray%20blue%20background%20clean%20minimal%20online%20safety%20concept%20photography%20soft%20even%20lighting%20trustworthy%20mood&width=900&height=600&seq=article-safety&orientation=landscape&nocache=true',
  'allchinabuy-review-pros-cons':
    'https://readdy.ai/api/search-image?query=A%20balanced%20scale%20with%20a%20thumbs%20up%20and%20a%20small%20star%20rating%20floating%20beside%20it%20on%20a%20warm%20neutral%20background%20clean%20minimal%20review%20concept%20photography%20soft%20studio%20lighting%20harmonious%20composition&width=900&height=600&seq=article-review&orientation=landscape&nocache=true',
  'allchinabuy-alternatives-comparison':
    'https://readdy.ai/api/search-image?query=Two%20smartphones%20side%20by%20side%20showing%20different%20shopping%20apps%20with%20a%20small%20arrow%20between%20them%20on%20a%20light%20neutral%20background%20clean%20minimal%20comparison%20concept%20photography%20bright%20airy%20lighting&width=900&height=600&seq=article-alternatives&orientation=landscape&nocache=true',
};

export default function ArticlesSection() {
  const { t, i18n } = useTranslation();
  const articles = getArticles(i18n.language);
  const featured = articles[0];
  const rest = articles.slice(1);

  return (
    <section id="articles" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
          {t('home.articlesTitle')}
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
          {t('home.articlesSubtitle')}
        </p>
      </div>

      {/* Featured article */}
      <div className="mt-12 grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
        <Link
          to={`/article/${featured.slug}`}
          className="group overflow-hidden rounded-lg border border-background-200 cursor-pointer"
        >
          <img
            src={articleImages[featured.slug]}
            alt={featured.title}
            title={featured.title}
            className="h-64 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-80"
          />
        </Link>

        <div className="flex flex-col items-start">
          <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            {t('home.articleMeta')}
          </span>
          <h3 className="mt-4 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
            {featured.title}
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {featured.metaDescription}
          </p>
          <Link
            to={`/article/${featured.slug}`}
            className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            {t('home.articleReadMore')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      {/* Grid of remaining articles */}
      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {rest.map((article) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
          >
            <div className="h-40 w-full overflow-hidden">
              <img
                src={articleImages[article.slug]}
                alt={article.title}
                title={article.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-heading text-base font-semibold leading-snug text-foreground-900">
                {article.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {article.metaDescription}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700 whitespace-nowrap">
                {t('home.readNow')}
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}